module.exports = __webpack_public_path__ + "static/media/arrow-pointing-to-right.abd95a8e.svg";